import { ReactElement } from "react";
import styled from "styled-components";

const Bar = styled.div`
  background: hsla(225, 20%, 92%, 0.9);
  height: 0.25rem;
  width: 20%;
  border-radius: 24px;
`;

const FilledBar = styled(Bar)<{ width: number }>`
  background: ${(props) => props.theme.colors.primary};
  transition: width 0.5s ease-out;
  width: ${({ width }) => `${width}%`};
`;

interface ProgressBarProps {
  progress: number;
  label?: string;
  width?: number;
}

const ProgressBar = ({ progress }: ProgressBarProps): ReactElement => {
  return (
    <Bar>
      <FilledBar width={progress} />
    </Bar>
  );
};

export default ProgressBar;
